import alertModal from './AlertModal'
import confirmModal from './ConfirmModal'
import deleteModal from './DeleteModal'
import drawerModal from './DrawerModal'
import editModal from './EditModal'
import emptyModal from './EmptyModal'

const modalTypes = {
  alertModal,
  confirmModal,
  deleteModal,
  drawerModal,
  editModal,
  emptyModal
}

export default modalTypes
